import { useSessionSharingPolicy } from '@heidi/workspace';

/**
 * Returns whether session link sharing is allowed for the current user's org or
 * standalone team. See `useSessionSharingPolicy` for the resolution order.
 */
export function useIsLinkSharingAllowed(): boolean {
  return useSessionSharingPolicy().isLinkSharingAllowed;
}
